import { ColumnConfig } from '../hooks/useTablePreferences';

export const meetingTypeColumns: ColumnConfig[] = [
  {
    key: 'name',
    label: 'Name',
    defaultWidth: 220,
    minWidth: 160,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'userType',
    label: 'User Type',
    defaultWidth: 130,
    minWidth: 100,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'type',
    label: 'Category',
    defaultWidth: 180,
    minWidth: 140,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'summaryType',
    label: 'Summary Type',
    defaultWidth: 180,
    minWidth: 140,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'yomanId',
    label: 'Yoman ID',
    defaultWidth: 130,
    minWidth: 100,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'interval',
    label: 'Duration (min)',
    defaultWidth: 120,
    minWidth: 100,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
];
